import PinInput from "app/components/PinInput";
import {
  AppStateActions,
  useAppDispatch,
  useAppState,
} from "app/providers/AppStateProvider";
import Text from "app/styles/Text";
import useFinalizeRequest from "../hooks/useFinalizeRequest";

export default function VerifyOtp({ onDone }: { onDone: () => void }) {
  const { bushaAuthToken, payment } =
    useAppState();

  const dispatch = useAppDispatch();
  const { finalizePaymentRequest, isLoading: isLoadingFinalizeRequest } = useFinalizeRequest();

  const onPinCompleted = (code: string) => {
    finalizePaymentRequest({
      token: bushaAuthToken!,
      paymentRequestId: payment?.id!,
      code,
    }, {
      onSuccess(data) {
        dispatch({
          type: AppStateActions.setPayment,
          payload: data.data.data,
        });
        onDone();
      },
    });
  }

  return (
    <div tw="flex flex-col gap-[24px] justify-center">
      <Text subdued medium>
        {payment?.two_step?.message ?? "Please check your authenticator app for your generated 6-digit code."}
      </Text>

      <PinInput onPinCompleted={onPinCompleted} disabled={isLoadingFinalizeRequest} />
    </div>
  )
}
